import { AbstractControl, ValidationErrors } from '@angular/forms';

import { SpecialValidationType } from '@app/origami-api/constants/validation-type';
import {
  FakeFormControl,
  SpecialValidatorFnFactory,
} from '@app/shared/utils/special-validators/special-validators.model';

export const createAlphaValidator: SpecialValidatorFnFactory = function () {
  return function (control: AbstractControl | FakeFormControl): ValidationErrors | null {
    const regex = /^[a-zA-Z_]+$/;
    const value = control.value;
    const result = regex.test(value) || !value;

    return result ? null : { [SpecialValidationType.Alpha]: { value } };
  };
};
